export const DEFAULT_MAX_NUM_WORK_ITEMS_TO_LINK = 200;
export const DEFAULT_MAX_HISTORY_ITEMS_COUNT = 100;
export const MAX_DESCRIPTION_LENGTH = 4000;
export const NO_PULL_REQUEST_FOUND = -1;